import { TimeLineTable, zonedToUTC, zonedToUTCAdd1Day } from '@fareye/common'
import { RenderControl } from '@fareye/ui'
import {
  cancelToken,
  dMmm,
  getQueryParams,
  getXlsx,
  groupBy,
  HEADERS,
  isEmpty,
  post
} from '@fareye/utils'
import queryString from 'query-string'
import React, { useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import { getTableColumns } from './Column'
import { downloadToCSV } from '@fareye/common'

const initApiResponse = {
  data: [],
  isLoading: false,
  isError: false,
  isSuccess: true,
  message: '',
  meta: {
    count: 0,
    pageNumber: 1
  }
}
const aggs = ['in_state', 'status', 'transport_mode']

export const ContainerListTable = React.memo((props: any) => {
  let {
    // data,
    match,
    config,
    baseUrl,
    endDate,
    fileName,
    location,
    startDate,
    searchData,
    selectedKey,
    searchQuery,
    refreshableTable = true,
    globalSearch
  } = props
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0
  })

  // TODO : Columns to be passed only from unique prop

  const [downloadLoading, setDownloadLoading] = React.useState<boolean>(true)
  const [refresh, setRefresh] = React.useState<boolean>(true)
  const [apiData, setApiResponse] = React.useState<any>(initApiResponse)
  const [sorting, setSortBy] = React.useState({
    sortBy: '',
    sortByDirection: true
  })
  const { route, transporter } = match.params
  const source = cancelToken().source()
  const [changeDetect, setChangeDetect] = React.useState(false)
  const [pageNo, setPageNo] = React.useState(0)
  const [recordsPerPage, setRecordsPerPage] = React.useState(20)
  const query: any = queryString.parse(location.search)
  const { transportMode = 'ocean' } = query
  const [showCommentModule, setShowCommentModule] = React.useState(false)
  const { style, className, variant } = config.styling
  const {
    links,
    apiConfig,
    downloadApiConfig,
    sortingMapping,
    showTimezone
  } = config.config
  const { sortBy, sortByDirection } = sorting
  const searchParams = {
    ...query,
    // startDate,
    // endDate,
    pageNo: pageNo + 1,
    recordsPerPage,
    sortByDirection: sortBy ? (sortByDirection ? 'desc' : 'asc') : '',
    ...searchQuery,
    ...(apiConfig && apiConfig.queryParams)
  }
  // const queryParam = getQueryParams(searchParams)
  const modifyResult = (resultSet: any) => {
    let countOfException = query.exceptions - 4

    const dataLength = resultSet.length - 1
    return resultSet.map((item: any, index: number) => {
      let randomNumber =
        index === 0 || index === dataLength ? 0 : Math.floor(Math.random() * 4)
      countOfException =
        countOfException >= randomNumber ? countOfException - randomNumber : 0
      if (index === 0) {
        return dataLength !== 0
          ? { ...item, exceptionCount: 4 }
          : { ...item, exceptionCount: query.exceptions }
      } else if (index === dataLength) {
        return {
          ...item,
          exceptionCount: countOfException ? countOfException : 0
        }
      } else if (index !== 0) {
        return { ...item, exceptionCount: countOfException ? randomNumber : 0 }
      }
    })
  }
  // const tempPaginator = (paginateProps: any) => {
  //   const { count } = apiData.meta
  //   return (
  //     <TablePaginaton
  //       {...paginateProps}
  //       // refreshing={refresh}
  //       // setRefresh={setRefresh}
  //       activateRefresh={false}
  //       showPagination={true}
  //       page={pageNo}
  //       pageSizeOptions={[]}
  //       canNext={Math.floor(count / recordsPerPage) > pageNo}
  //       canPrevious={pageNo > 0}
  //       commentingModule={() => setShowCommentModule(true)}
  //       downloadCSV={downloadCSV}
  //       totalElements={count}
  //     />
  //   )
  // }
  // Object.assign(ReactTableDefaults, {
  //   PaginationComponent: tempPaginator
  // })
  //   const subComponentConfig = config.children
  //   const tableLinks: any = { ...links }

  const selectedColumn = React.useMemo(() => {
    const columns = config.config.columnsList

    return getTableColumns(columns, {
      links: config.config.links,
      queryParams: {}
    })
  }, [selectedKey])

  const isFirstRun = useRef(false)
  React.useEffect(() => {
    if (isFirstRun.current) {
      setPageNo(0)
      setApiResponse(initApiResponse)
      setChangeDetect(!changeDetect)
    }
    isFirstRun.current = true
  }, [startDate, endDate, globalSearch, recordsPerPage])

  React.useEffect(() => {
    fetchData()
  }, [pageNo, sorting, selectedKey, changeDetect])

  function generateFilterDataFromGlobalSearch(globalSearch: any[]) {
    if (isEmpty(globalSearch)) {
      return []
    } else {
      const groupedSearch = groupBy(globalSearch, ele => ele.key)
      return Object.entries(groupedSearch).map(([key, value]) => {
        return [
          {
            filterKey: key,
            filterValue: value.reduce((res = [], obj) => {
              res.push(obj.value)
              return res
            }, []),
            condition: 'include',
            filterType: 'eq'
          }
        ]
      })
    }
  }

  function generateFilterObjectForDateRange(startDate: any, endDate: any) {
    const startFilter = [
      {
        filterKey: 'start_date',
        filterValue: startDate ? zonedToUTC(startDate) : new Date(),
        condition: 'include',
        filterType: 'gte'
      }
    ]
    const endFilter = [
      {
        filterKey: 'start_date',
        filterValue: endDate ? zonedToUTCAdd1Day(endDate) : new Date(),
        condition: 'include',
        filterType: 'lt'
      }
    ]

    const locationFilter: any =
      selectedKey === 'normal'
        ? []
        : [
            {
              filterKey: 'in_state',
              filterValue: 'in_transit',
              condition: 'include',
              filterType: 'eq'
            }
          ]

    return [locationFilter, startFilter, endFilter]
  }

  function generateSortingObj() {
    const { sortByDirection, sortBy } = sorting
    if (sortBy) {
      const sort = [{ sortBy, sortDir: sortByDirection ? 'asc' : 'desc' }]
      return { sort }
    } else {
      return {}
    }
  }

  async function fetchData() {
    try {
      setApiResponse({
        ...apiData,
        isLoading: true
      })
      let filter: any = generateFilterDataFromGlobalSearch(globalSearch)
      const dateFilter = generateFilterObjectForDateRange(startDate, endDate)
      filter = [...filter, ...dateFilter]
      const { apiURL } = apiConfig
      const {
        data: { results, meta }
      } = await post(
        apiURL,
        {
          filter,
          perPage: recordsPerPage,
          page: pageNo + 1,
          aggs,
          ...generateSortingObj()
        },
        source.token,
        {
          headers: HEADERS()['HEADER_INFLECTION']
        }
      )
      setApiResponse({
        ...apiData,
        data: modifyResult(results),
        isSuccess: true,
        meta: meta,
        isError: false,
        message: isEmpty(results) ? 'No Data Found...' : '',
        isLoading: false
      })
    } catch (ex:any) {
      setApiResponse({
        data: [],
        isSuccess: false,
        isError: true,
        message: 'Something went wrong...',
        isLoading: false
      })
    }
  }

  async function downloadCSV() {
    setDownloadLoading(true)
    delete searchParams.pageNo
    delete searchParams.recordsPerPage
    const queryParam = getQueryParams({
      ...searchParams,
      ...downloadApiConfig.queryParams,
      plant: props.plant ? props.plant : ''
    })
    const { data } = await getXlsx(
      `${downloadApiConfig && downloadApiConfig.apiURL}?${queryParam}`,
      source.token
    )
    downloadToCSV({
      data,
      fileName: fileName || `${dMmm()}`,
      type: 'text/zip',
      extension: 'zip'
    })
    setDownloadLoading(false)
  }

  return (
    <RenderControl state={apiData} variant={'xl'}>
      <div
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          ...style,
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          boxSizing: 'border-box',
          padding: '16px 16px 50px'
        }}
      >
        <TimeLineTable
          variant={selectedKey === 'tabular' ? '' : 'card'}
          className={`responsive ${
            selectedKey === 'tabular' ? 'striped' : ''
          } ${className} multi-model`}
          data={apiData.data}
          columns={selectedColumn}
          totalElements={apiData.data.length}
          getTrProps={({ row: { original } }: any) => ({
            style: {
              backgroundColor: original.exceptionsCount ? '#FCF1F1' : '#fff'
            }
          })}
          refresh={setRefresh}
          refreshing={refresh}
          downloadLoading={downloadLoading}
          downloadCSV={downloadCSV}
          commentingModule={() => setShowCommentModule(true)}
          showPagination={false}
          onSortedChange={(ev: any) => {
            setSortBy({
              sortBy: sortingMapping[ev[0].id]
                ? sortingMapping[ev[0].id]
                : ev[0].id,
              sortByDirection:
                ev[0].id === sorting.sortBy
                  ? !sorting.sortByDirection
                  : ev[0].desc
            })
          }}
          onPageChange={(pageIndex: number) => setPageNo(pageIndex)}
        />
      </div>
    </RenderControl>
  )
})

// export default withRouter(TripTable)
// export default MultiModalTable
